// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.inv_sterilization_method_enum */
var InvSterilizationMethodEnum;
(function (InvSterilizationMethodEnum) {
    InvSterilizationMethodEnum["AUTOCLAVE"] = "AUTOCLAVE";
    InvSterilizationMethodEnum["FILTRATION"] = "FILTRATION";
    InvSterilizationMethodEnum["UV"] = "UV";
    InvSterilizationMethodEnum["CHEMICAL"] = "CHEMICAL";
    InvSterilizationMethodEnum["DRY_HEAT"] = "DRY_HEAT";
    InvSterilizationMethodEnum["OTHER"] = "OTHER";
})(InvSterilizationMethodEnum || (InvSterilizationMethodEnum = {}));
;
export default InvSterilizationMethodEnum;
/** Zod schema for inv_sterilization_method_enum */
export const invSterilizationMethodEnum = z.nativeEnum(InvSterilizationMethodEnum);
//# sourceMappingURL=InvSterilizationMethodEnum.js.map